export default __webpack_public_path__ + "static/media/april-2017-school-day.a829db94.csv";